import { BiQueryResult } from '@euler/model/bi/result';
import {
  BiChartViz,
  BiFunnelViz,
  BiKpiGroupViz,
  BiVizType,
} from '@euler/model/bi/viz';
import { memo, useMemo } from 'react';
import { BiResultTable } from './BiResultTable';
import { BiVizMismatch } from './BiVizMismatch';
import { biVizLook } from './functions/biVizLook';
import { biTableOfViz } from './functions/biVizTable';

/**
 * A chart's result table: the rows behind it, as the chart draws them; a
 * funnel's stages with their rates; a KPI group's numbers, one per row.
 */
export const BiChartTableView = memo(
  ({
    viz,
    result,
    inlineCopy,
  }: {
    viz: BiChartViz | BiFunnelViz | BiKpiGroupViz;
    result: BiQueryResult;
    /** False where the container offers 复制数据 itself. */
    inlineCopy?: boolean;
  }) => {
    const table = useMemo(() => biTableOfViz(viz, result), [viz, result]);
    if (!table) return <BiVizMismatch />;
    const look = biVizLook(viz).table;
    // Funnel stages and a group's numbers do not add up: no totals row.
    return (
      <BiResultTable
        table={table}
        look={
          viz.type === BiVizType.Funnel || viz.type === BiVizType.KpiGroup
            ? { ...look, totalsRow: false }
            : look
        }
        inlineCopy={inlineCopy}
      />
    );
  },
);
